import React,{ useState } from "react";
import styled from "styled-components";
import { Facebook, Google, Twitter } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { auth } from "../firebase";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

function Login () {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const signIn = e => {
    e.preventDefault();

    auth
        .signInWithEmailAndPassword(email, password)
        .then(auth => {
          history.push('/my-account')
        })
        .catch(error => alert(error.message))
  }

  const googleSignIn = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        // Handle successful sign-in
        const user = result.user;
        history.push('/my-account')
      })
      .catch((error) => {
        // Handle sign-in error
        console.error(error);
      });
  };

  const facebookSignIn = () => {
    const provider = new firebase.auth.FacebookAuthProvider();
    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        // Handle successful sign-in
        const user = result.user;
        console.log(user);
        history.push('/my-account')
      })
      .catch((error) => {
        // Handle sign-in error
        console.error(error);
      });
  };

    return(
        <Container>
            <Title>
                <h2>Welcome back Login</h2>
                <p>Don't have an Account?<a href="/register">Register</a></p>
            </Title>

            <Form>
                <input type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Enter email" required />
                <input type="password" 
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter password" required/>
                <button type="submit" onClick={signIn}>Login</button>
            </Form>
            
            <OtherForm>
                <Other onClick={googleSignIn}><Google sx={{fontSize: "25px"}}/><p>Google</p></Other>
                <Other onClick={facebookSignIn}><Facebook sx={{fontSize: "25px"}}/>Facebook</Other>
              
            </OtherForm>
            <br />
        </Container>
    )
}

const Container = styled.div`
  width: 50vw;
  margin-top: 5%;
  margin-left: 25%;
  height: max-content;
  background-color: whitesmoke;

  @media(max-width: 768px) {
    width: 90vw;
    margin-left: 5%;
    margin-top: 15%;
  }

  @media (min-height: 1085px) {
    margin-left: 0;
    width: 100vw;
    margin-top: 15%;
  }
`;

const Title = styled.div`
  font-family: sans-serif;
  h2 {
    text-align: center;
    font-size: 18px;
    text-decoration: underline;
    font-style: oblique;

    &:hover {
        color: orange;
    }

    @media (min-height: 1085px) {
    font-size: 20px;
  }
  }

    p {
        text-align: right;
        font-size: 15px;
        margin-top: -2%;
        margin-right: 5%;
        font-style: oblique;

        a {
            color: black;
            text-decoration: none;
            font-style: 15px;
            font-style: oblique;

            &:hover {
                color: orange;
            }

            @media (min-height: 1085px) {
    font-size: 18px;
        }
    }
`;

const Form = styled.div`
  input {
    width: 40vw;
    height: 6vh;
    margin-top: 2%;
    margin-left: 10%;
    border: 1px solid black;

    @media (min-height: 1085px) {
      width: 80vw;
      height: 4.6vh;
    }

    &:hover {
        background: whitesmoke;
        border: 1px solid orange;
    }

    @media(max-width: 768px) {
        width: 70vw;
        height: 5vh;
        margin-top: 5%;
    }
  }
    button {
        width: 20vw;
        height: 7vh;
        color: whitesmoke;
        background: orange;
        align-items: center; 
        margin-top: 2%;
        margin-left: 30%;
        font-size: 19px;
        font-weight: 600;
        cursor: pointer;
        border: 1px solid whitesmoke;

        &:hover {
            color: orange;
            background: whitesmoke;
            border: 1px solid orange;
        }

        @media(max-width: 768px) {
            width: 35vw;
            height: 6vh;
            font-size: 15px;
            margin-top: 15px;
            font-family: sans-serif;
        }

        @media (min-height: 1085px) {
          width: 40vw;
          height: 5vh;
          font-size: 19px;
        }
    }
`;

const OtherForm = styled.div`
  display: flex;
  margin-top: 2%;
  justify-content: space-around;

  @media (max-width: 768px) {
    margin-top: 15px;
  }
`;

const Other = styled.button`
  width: max-content;
  height: 7vh;
  margin-top: 1%;
  cursor: pointer;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
  align-items: center;
  background: whitesmoke;
  border: 1px solid black;

  &:first-child{
    &:hover {
    background: green;
    color: white;
    }
  }

    &:hover {
    background: blue;
    color: white;
    }

  &:last-child{
    &:hover {
    background: lightblue;
    color: white;
    }
  }


  @media(max-width: 768px) {
    width: max-content;
    height: 5vh;
  }

  @media (min-height: 1085px) {
    font-size: 20px;
    font-weight: 700;
    width: 20vw;
    text-align: center;
    align-items: center;
  }
`;

export default Login